export default __webpack_public_path__ + "static/media/03.a3d7a1ec.jpg";